import React, { createContext, useContext, useEffect, useState } from 'react'
import { useExercise } from '../ExerciseProvider'

const DecisionMakingContext = createContext()

export const useDecisionMaking = () => {
  return useContext(DecisionMakingContext)
}

export const DecisionMakingProvider = ({ children }) => {
  const {
    updateDecisionMakingExerciseResponse,
    getDecisionMakingExerciseResponse,
    setContinueButtonDisabled,
    sectionIdx,
    exerciseIndex,
  } = useExercise()

  const [selectedValues, setSelectedValues] = useState(
    getDecisionMakingExerciseResponse('selected_values') || [],
  )

  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [exerciseIndex, sectionIdx])

  useEffect(() => {
    if (exerciseIndex === 0) {
      setContinueButtonDisabled(selectedValues.length < 8)
    } else if (exerciseIndex === 2) {
      setContinueButtonDisabled(
        getDecisionMakingExerciseResponse('positions') === undefined,
      )
    } else {
      setContinueButtonDisabled(false)
    }
  }, [selectedValues, sectionIdx, exerciseIndex])

  const addSelectedValue = (value) => {
    const newSelectedVals = [...selectedValues, value]
    setSelectedValues(newSelectedVals)
    updateDecisionMakingExerciseResponse('selected_values', newSelectedVals)
    const newSelectedValues =
      getDecisionMakingExerciseResponse('selected_values')
    const newValueImportance = getDecisionMakingExerciseResponse(
      'value_importance',
    )?.filter((option) => newSelectedValues.includes(option.value))
    updateDecisionMakingExerciseResponse('scored_options', newValueImportance)
    const newScoredOptions = getDecisionMakingExerciseResponse(
      'scored_options',
    )?.filter((option) => newSelectedValues.includes(option.value))
    updateDecisionMakingExerciseResponse('scored_options', newScoredOptions)
  }

  const clearSelectedValues = () => {
    setSelectedValues([])
    updateDecisionMakingExerciseResponse('selected_values', selectedValues)
    updateDecisionMakingExerciseResponse('value_importance', [])
    updateDecisionMakingExerciseResponse('scored_options', [])
  }

  const removeValue = (value) => {
    const newSelectedValues = selectedValues.filter((v) => v !== value)
    setSelectedValues(newSelectedValues)
    updateDecisionMakingExerciseResponse('selected_values', newSelectedValues)
    const newValueImportance = getDecisionMakingExerciseResponse(
      'value_importance',
    )?.filter((option) => newSelectedValues.includes(option.value))
    updateDecisionMakingExerciseResponse('scored_options', newValueImportance)
    const newScoredOptions = getDecisionMakingExerciseResponse(
      'scored_options',
    )?.filter((option) => newSelectedValues.includes(option.value))
    updateDecisionMakingExerciseResponse('scored_options', newScoredOptions)
  }

  const handleSelectValue = (value) => {
    if (selectedValues.includes(value)) {
      removeValue(value)
    } else {
      addSelectedValue(value)
    }
  }

  const value = {
    selectedValues,
    handleSelectValue,
    clearSelectedValues,
  }

  return (
    <DecisionMakingContext.Provider value={value}>
      {children}
    </DecisionMakingContext.Provider>
  )
}
